/*
 * @FilePath     : /es-package/packages/es-mpx-template/src/plugins/store.js
 * @Author       : LiYang
 * @Date         : 2021-09-14 15:24:34
 * @LastEditTime : 2021-12-30 16:49:25
 * @LastEditors  : Please set LastEditors
 * @Description  : 衍生store供页面使用无需再import
 */

import store from '@/store'

export default app => {
  app.injectMixins({
    computed: {
      $mpxStore () {
        return store
      }
    }
  }, 'page')
}
